/**
 * KAN-752: карточка пользователя (оператора) и создание оператора-кампании.
 *
 * Ключи под общим префиксом USERS_QUERY_KEY: список пользователей
 * (['users', filters]) и карточка обновляются одной инвалидацией.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usersApi } from '@/services/api/users';
import { USERS_QUERY_KEY } from '@/services/api/queryKeys';
import type { User } from '@/types/user';

export function userDetailKey(id: string) {
  return [...USERS_QUERY_KEY, 'detail', id] as const;
}

export function useUser(id: string) {
  return useQuery({
    queryKey: userDetailKey(id),
    queryFn: () => usersApi.getById(id),
    enabled: Boolean(id),
  });
}

/** После создания кампании обновляется список пользователей. */
export function useCreateCampaignOperator() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => usersApi.createCampaignOperator({ name }),
    onSuccess: (user: User) => {
      client.setQueryData(userDetailKey(user.id), user);
      client.invalidateQueries({ queryKey: USERS_QUERY_KEY });
    },
  });
}
